import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSpring, animated } from "react-spring";
import {
  Background,
  ModalContent,
  CloseModalButton,
  Form,
  FormContent,
  Button,
  Input,
  Select,
  Label,
} from "../../ModalRegisterStyle";
import Swal from "sweetalert2";
import api from "../../../../services/api";

export default function ModalRegister({ showModal, setShowModal }) {
  const [matricula, setMatricula] = useState("");
  const [nome, setNome] = useState("");
  const [vinculo, setVinculo] = useState("Selecione vínculo");
  const [apelido, setApelido] = useState("");
  const modalRef = useRef();
  const animation = useSpring({
    config: {
      duration: 150,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`,
  });
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 1000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) setShowModal(!showModal);
    },
    [setShowModal, showModal]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  /**
   * Vai servir para gerar o pdf do relatório
   * @param {Previne o evento padrão da função} e
   */
  async function handleSubmit(e) {
    e.preventDefault();
    const data = {
      matricula: matricula,
      nome: nome,
      vinculo: vinculo,
      apelido: apelido,
    };
    try {
      const response = await api.post(`rh/contributors`, { data });
      if (response.data.error) {
        return Swal.fire("Atenção!", response.data.error, "warning");
      }
      Swal.fire("Sucesso!", response.data.success, "success");
      Toast.fire({
        icon: "success",
        title: "Cadastrado com sucesso!",
      });
      setShowModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      alert(error);
    }
  }

  return (
    <>
      {showModal ? (
        <Background
          ref={modalRef}
          onClick={(e) => {
            if (modalRef.current === e.target) {
              setShowModal(!showModal);
            }
          }}
        >
          <animated.div style={animation}>
            <ModalContent>
              <br />
              <Form onSubmit={handleSubmit}>
                <h3>Cadastrar Colaborador</h3>
                <FormContent>
                  <Label>Matrícula:</Label>
                  <Input
                    type="number"
                    value={matricula}
                    placeholder="Matrícula"
                    onChange={(e) => setMatricula(e.target.value)}
                    required
                  />
                  <Label>Nome:</Label>
                  <Input
                    type="name"
                    value={nome}
                    placeholder="Nome"
                    onChange={(e) => setNome(e.target.value.toUpperCase())}
                    required
                  />
                  <Label>Vínculo:</Label>
                  <Select
                    type="text"
                    value={vinculo}
                    placeholder="Vínculo"
                    onChange={(e) => setVinculo(e.target.value)}
                    required
                  >
                    <option hidden>Selecione vínculo</option>
                    <option value="ESTATUTARIO">ESTATUTARIO</option>
                    <option value="TEMPORARIO - CLT">TEMPORARIO - CLT</option>
                  </Select>
                  <Label>Apelido:</Label>
                  <Input
                    type="name"
                    value={apelido}
                    placeholder="Apelido"
                    onChange={(e) => setApelido(e.target.value.toUpperCase())}
                    required
                  />
                </FormContent>
                <br />
                <Button type="submit">Cadastrar</Button>
              </Form>
              <CloseModalButton
                onClick={() => {
                  setShowModal(!showModal);
                }}
              />
            </ModalContent>
          </animated.div>
        </Background>
      ) : null}
    </>
  );
}
